import React from 'react'
import PIXE_ICON from '../assets/pixe.png'

export default function PixeTokenIcon({
  size = 18,
  className = '',
  ariaLabel = 'PIXE token',
}: {
  size?: number
  className?: string
  ariaLabel?: string
}) {
  const px = Math.max(10, Math.floor(size))
  return (
    <span
      className="inline-flex items-center justify-center rounded-full bg-black overflow-hidden shrink-0"
      style={{ width: px, height: px }}
    >
      <img
        src={PIXE_ICON}
        alt={ariaLabel}
        width={px}
        height={px}
        className={['h-full w-full object-contain', className].join(' ')}
        loading="lazy"
        decoding="async"
      />
    </span>
  )
}
